export default __webpack_public_path__ + "static/BYOD-06e707fe8a97f6260e9dffef7163441f.png";